import { render, staticRenderFns } from "./ReasonforVisit.vue?vue&type=template&id=36cc9587&"
import script from "./ReasonforVisit.vue?vue&type=script&lang=js&"
export * from "./ReasonforVisit.vue?vue&type=script&lang=js&"
import style0 from "./ReasonforVisit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports